<template>
    <base-chats :data="data" :loading="loading" @search="search($event)" />
</template>

<script>
export default {
    components: {
        baseChats: () => import("./baseChats.vue"),
    },
    data() {
        return {
            loading: false,
            data: [],
            filtersNumber: ""
        }
    },
    created() {
        this.fetchNumbers();
    },
    methods: {
        search(number) {
            this.filtersNumber = number;
            this.fetchNumbers();
        },
        async fetchNumbers() {
            try {
                this.loading = true;
                const response = await this.$axios.get("/whatsapp/message/manager_dialogs", { params: { filtersNumber: this.filtersNumber } });
                this.data = response.data.data;
                this.loading = false;
            } catch (error) {
                console.error(error);

            }
        }
    }
}
</script>